import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { AuroraThemeType } from '../../../utils/themes/ThemeProvider'

type Props = {
  size?: number | string
}

export const ResourceCoordinationBenefitIllustration: FunctionComponent<Props> = ({ size = 72 }) => {
  const { colors } = useTheme() as AuroraThemeType
  const { benefitIllustration } = colors.icons
  return (
    <Svg width={size} height={size} viewBox='0 0 72 72' fill='none'>
      <Path
        d='M62.8002 40.4724C62.7405 41.1454 62.4331 41.7939 62.0917 42.1102C61.4002 42.7472 61.3874 42.7385 61.0616 42.9941C57.782 45.5708 53.9917 47.1076 49.8698 47.5683C43.0248 48.3324 36.1284 45.5015 31.6879 40.1705C29.5267 37.575 27.8933 34.5145 27.1051 31.1998C26.1219 27.0647 25.8487 22.6898 26.9187 18.6298C26.9557 18.4869 26.9969 18.3367 27.0382 18.1792C27.3654 16.9617 27.8193 15.422 28.3102 15.1259C28.3315 15.1129 28.3557 15.1071 28.3799 15.1057L29.6647 15.0291L30.1641 15.0003H30.1755C30.2438 15.0003 30.3106 15.0017 30.3761 15.0017C31.7078 15.0003 32.6056 14.8977 32.8062 16.537C32.8788 17.1321 32.9727 17.6694 33.0837 18.1792C33.2928 19.144 33.566 20.0077 33.8875 20.9697C34.3997 22.505 35.4925 24.436 36.2238 25.6088C38.8744 29.8638 41.4398 32.7048 45.7167 35.072C47.858 36.2578 51.6683 37.1822 54.097 37.4162C55.6379 37.5635 60.7884 37.9072 62.0092 38.6626C62.436 38.9255 62.6665 39.314 62.7604 39.7401C62.813 39.9769 62.823 40.2268 62.8002 40.4724Z'
        fill={benefitIllustration.primary.fill}
      />
      <Path
        d='M36.9579 33.6788C35.2534 31.9312 32.4903 31.3188 30.1455 31.5976C28.5634 31.7853 27.0097 32.3096 25.6651 33.1748C24.1939 31.5802 21.9274 31.0184 19.7833 31.4286C17.1539 31.9312 15.2758 34.2334 14.4677 36.7047C13.5827 39.4085 14.0537 42.3794 15.0468 44.9807C16.0783 47.6815 17.3859 50.6814 19.8999 52.2759C21.2986 53.1628 23.1553 53.5556 24.7375 52.9663C25.2667 52.7699 25.7732 52.4854 26.2214 52.1301C27.519 53.3751 29.464 53.9239 31.2112 53.5426C33.8121 52.9735 35.4056 50.2958 36.4997 48.0585C37.6792 45.6494 38.4689 43.0713 38.7762 40.3978C39.0465 38.0494 38.6567 35.4236 36.9564 33.6803L36.9579 33.6788Z'
        fill={benefitIllustration.secondary.fill}
      />
      <Path
        d='M26.3857 33.27C26.3857 33.27 25.7112 25.3017 18.5247 25.4967C18.5247 25.4967 16.722 33.1242 26.3857 33.27Z'
        fill={benefitIllustration.secondary.fill}
      />
      <Path
        d='M26.9687 27.548C26.2502 28.897 25.6953 30.3197 25.3282 31.8044C24.9654 33.2776 27.2348 33.9059 27.599 32.4313C27.9191 31.1357 28.3744 29.9153 29.0019 28.7381C29.7147 27.4007 27.6829 26.2077 26.9687 27.548Z'
        fill={benefitIllustration.secondary.fill}
      />
      <Path
        d='M33.0845 18.1792H27.0391C27.3663 16.9617 27.8202 15.422 28.311 15.1259C28.3324 15.1129 28.3566 15.1071 28.3808 15.1057L29.6655 15.0291L30.165 15.0003H30.1763C30.2446 15.0003 30.3115 15.0017 30.3769 15.0017C31.7087 15.0003 32.6065 14.8977 32.8071 16.537C32.8796 17.1321 32.9736 17.6694 33.0845 18.1792Z'
        fill={benefitIllustration.secondary.fill}
      />
    </Svg>
  )
}
